'use client';

import { getCookie } from 'cookies-next';
import { create } from 'zustand/index';
import { persist } from 'zustand/middleware';

import { AppLanguage, appLanguages } from '@/features/i18n/AppLanguage';
import { defaultAppLanguage } from '@/features/i18n/defaultAppLanguage';
import { CookieKey } from '@/utils/CookieKey';


type AppLanguageStoreType = {
  appLanguage: AppLanguage;
};

type AppLanguageStoreActions = {
  setAppLanguage: (appLanguage: AppLanguage) => void;
};

export const useAppLanguageStore = create<AppLanguageStoreType & AppLanguageStoreActions>()(
  persist(
    set => {

      // TODO: Doesn't work, also must synced with getI18nConfig
      let initialAppLanguage: AppLanguage = getCookie(CookieKey.appLanguage) as AppLanguage;
      if (!appLanguages.includes(initialAppLanguage)) {
        initialAppLanguage = defaultAppLanguage;
      }

      return {
        appLanguage: initialAppLanguage,
        setAppLanguage: appLanguage => set({ appLanguage })
      };
    },
    {
      name: 'app-language-store',
      version: 1
    }
  )
);
